<template>
  <div>
    <v-container>
      <v-row class="elevation-1">
        <v-col>
          <v-select id="treasurersChecksReportTypeSelect"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showBank')">
        <v-col cols="6">
          <MultiItemSelect id="treasurersChecksReportBankSelect"
            label="By Banks"
            item-text="bankName"
            item-value="_id"
            :item-list="bankList"
            :items="criteria.banks"
            @selected-items="selectedBanks"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showFromToDates')">
        <v-col id="treasurersChecksReportFromDate">
          <ClarionDateControl
            v-model="criteria.fromDate"
            :isToggle="false"
            :isRequired="false" label="From Date" />
        </v-col>
        <v-col id="treasurersChecksReportToDate">
          <ClarionDateControl
            v-model="criteria.toDate"
            :isToggle="false"
            :isRequired="false" label="To Date" />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showOutstandingOnly')">
        <v-col cols="4">
          <v-checkbox
            id="treasurersChecksReportOutstandingOnlyCheckBox"
            v-model="criteria.outstandingOnly"
            label="Print outstanding only">
          </v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import MultiItemSelect from '@/components/common/base/MultiItemSelect.vue';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import ReportChip from '../../../reports/ReportChip.vue';
import { reportList, queryStringCalc } from './report-util';
import { getRawJwt } from '../../../../util/jwt';
import { toShortDate } from '../../../../util/shared/tmc-global';

const bankListCrudKey = 'treasurersChecksReportBankList';

export default {
  name: 'TreasurersChecksReportComp',
  components: {
    ReportChip,
    ClarionDateControl,
    MultiItemSelect,
  },
  data: () => ({
    criteria: {
      banks: [],
      fromDate: undefined,
      toDate: undefined,
      outstandingOnly: false,
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allBanks: false,
    },
  }),
  created() {
    this.loadbanks();
    this.initCriteria();
  },
  computed: {
    ...mapGetters('base/crud', ['items']),
    ...mapGetters(['todaysDate']),
    ...mapState({
      devSettingItem: (state) => state.SystemConfig.devSettingItem || {},
    }),
    bankList() {
      return this.items(bankListCrudKey) || [];
    },
    reports() {
      return [
        ...reportList(),
      ];
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: getRawJwt(),
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
      });
    },
    validateCriteria() {
      return this.reportConfig.route !== '';
    },
  },
  methods: {
    ...mapActions('shared/bank', ['loadBanks']),
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    loadbanks() {
      this.loadBanks({ criteria: {}, baseCrudKey: bankListCrudKey }).then(() => {
        this.criteria.banks = this.mapCollectionVal(this.bankList, '_id');
        this.criteriaStats.allBanks = true;
      });
    },
    selectedBanks(val) {
      this.criteria.banks = val;
      this.criteriaStats.allBanks = (val || []).length === this.bankList.length;
    },
    showReportConfig(configField) {
      return this.reportConfig.filters[`${configField}`];
    },
    initCriteria() {
      this.criteria.fromDate = toShortDate(this.todaysDate);
      this.criteria.toDate = toShortDate(this.todaysDate);
    },
  },
};
</script>
